import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/pro-regular-svg-icons/faSquare";
import { faSquareCheck } from "@fortawesome/pro-solid-svg-icons/faSquareCheck";
import { faSquareMinus } from "@fortawesome/pro-solid-svg-icons/faSquareMinus";
export const Icon = _jsx(FontAwesomeIcon, { icon: faSquare });
export const CheckedIcon = _jsx(FontAwesomeIcon, { icon: faSquareCheck });
export const IndeterminateIcon = _jsx(FontAwesomeIcon, { icon: faSquareMinus });
//# sourceMappingURL=CheckboxIcons.js.map